import { ReactNode } from 'react';

// Components
import { HeaderConversations } from '@/components/layouts/wrappers/ConversationsWrapper/HeaderConversations';

export const ConversationsWrapper = (props: { children: ReactNode }) => {
    const { children } = props;

    return (
        <>
            <HeaderConversations />
            <div className="max-h-[78vh] flex-1">
                <div className="flex h-full flex-col outline-none">{children}</div>
            </div>
        </>
    );
};
